import {applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {CoreDI, inversifyContainer, ScrollContainer, ScrollContainerOptions, System} from '@gongxigames/framework/core';

export type ScrollProps = {
    x?: number;
    y?: number;
} & ScrollContainerOptions;

export const ScrollComponent = PixiComponent<ScrollProps, ScrollContainer>('Scroll', {
    create(props: ScrollProps): ScrollContainer {
        return new ScrollContainer(
            props,
            inversifyContainer.get(CoreDI.UpdateManager),
            inversifyContainer.get<System>(CoreDI.System).view
        );
    },
    applyProps(instance: ScrollContainer, oldProps: ScrollProps, newProps: ScrollProps): void {
        applyDefaultProps(instance, oldProps, newProps);
    }
});
